import React, { useState, useRef, useEffect } from 'react';
import {
  Tag, Input, Tooltip, Button,
} from 'antd';
import { PropTypes } from 'prop-types';

const TagInput = ({
  selectedTags, onChange, addText, className,
}) => {
  const [tags, setTags] = useState(selectedTags);
  const [inputVisible, setInputVisible] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const textInput = useRef(null);

  const handleClose = (removedTag) => {
    const newTags = tags.filter((tag) => tag !== removedTag);
    setTags(newTags);
    onChange(newTags);
  };

  const showInput = () => {
    setInputVisible(true);
  };

  useEffect(() => {
    setTags(selectedTags);
  }, [selectedTags]);

  useEffect(() => {
    if (inputVisible) {
      if (textInput.current) textInput.current.focus();
    }
  }, [inputVisible]);

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleInputConfirm = () => {
    let newTags = tags;
    if (inputValue && tags.indexOf(inputValue) === -1) {
      newTags = [...tags, inputValue];
    }
    setTags(newTags);
    setInputVisible(false);
    onChange(newTags);
    setInputValue('');
  };

  return (
    <div className={className}>
      {tags.map((tag) => {
        const isLongTag = tag.length > 20;
        const tagElem = (
          <Tag
            key={tag}
            closable
            onClose={() => handleClose(tag)}
          >
            {isLongTag ? `${tag.slice(0, 20)}...` : tag}
          </Tag>
        );
        return isLongTag ? <Tooltip title={tag} key={tag}>{tagElem}</Tooltip> : tagElem;
      })}
      {inputVisible && (
        <Input
          ref={textInput}
          type="text"
          size="small"
          style={{ width: 78 }}
          value={inputValue}
          onChange={(e) => handleInputChange(e)}
          onBlur={() => handleInputConfirm()}
          onPressEnter={() => handleInputConfirm}
        />
      )}
      {!inputVisible && (
        <Button style={{ marginBottom: 0 }} size="small" type="dashed" onClick={() => showInput()}>
          {`+ ${addText}`}
        </Button>
      )}
    </div>
  );
};

TagInput.propTypes = {
  selectedTags: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func.isRequired,
  addText: PropTypes.string,
  className: PropTypes.string,
};

TagInput.defaultProps = {
  selectedTags: [],
  addText: 'New Tag',
  className: null,
};

export default TagInput;
